<script>
import axios from "axios";
import {StorePath,MenuPath} from "@/path";
import Swal from "sweetalert2";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
export default {
  computed: {
    StorePath() {
      return StorePath
    }
  },
  props : ['selected_item'],
  components: {
    SelectWithSearch

  },
  data(){
    return {
      stores : [],
      base_url : process.env.VUE_APP_API_BACKEND_URL,
      filter : [],
      fields : ["r_id","restaurant_name","brand","location","toggle","Actions"],
      restaurants :[],
      selected_store : null,
      store_reload : 0,
      search : '',
      current_page : 1
    }
  },
  watch : {
    search(){
      this.getStores();
    },
    current_page(){
      this.getStores();
    }
  },
  mounted(){
    this.getStores();
  },
  methods : {
    async getStores(){
      try {
        let res = await axios.get(this.base_url + StorePath.GET_STORES,{
          params : {
            item_id : this.selected_item.id,
            search : this.search,
            page : this.current_page
          }
        });
        if(res.data.status){
          this.stores = res.data.data;
        }
      }catch (e) {
        console.log(e);
      }
    },
    reloadStore(){
      this.selected_store = null;
      this.store_reload += 1;
    },
    async saveItemTag(){
        try {
          let res = await axios.post(this.base_url + StorePath.STORE_ITEM_TAG,{
            'item_id' : this.selected_item.id,
            'ids' : [this.selected_store]
          });
          if(res.data.status){
            Swal.fire('success','','success');
            this.getStores();
          }
        }catch (e){
          console.log(e);
        }
    },
    async toggleItem(e,store){
      try {
        let res = await axios.post(this.base_url + MenuPath.MENU_ITEM_STOCK_OUT,{
          item_id : this.selected_item.id,
          store_id : store.id,
          status : e ? true : false
        });
        if(res.data.status){
          this.$bvToast.toast('Item of store ' + store.name + (e ? ' Enabled Successfully' : ' Disabled Successfully'),{
            title: `Item `+ e ? 'Stocked In Successfully' : 'Stocked Out Successfully',
            variant: 'success',
            solid: true
          });
        }else{
          this.$bvToast.toast("Failed to toggle",{
            title: `Item `+ e ? 'Stocked In Failed' : 'Stocked Out Failed',
            variant: 'danger',
            solid: true
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteItemTag(v){
      try {
        let res = await axios.post(this.base_url + StorePath.STORE_ITEM_TAG,{
          'item_id' : this.selected_item.id,
          'ids' : [v],
          'type' : 'delete'
        });
        if(res.data.status){
          Swal.fire('success','','success');
          this.getStores();
        }
      }catch (e){
        console.log(e);
      }
    }
  }
}
</script>

<template>
  <div>
    <b-row class="mb-2">
      <b-col sm="4">
        <label>Store</label>
        <select-with-search :search_api="StorePath.SEARCH_STORE" track_by="id" display="name" @selectedOption="((v) => selected_store = v)"></select-with-search>
      </b-col>
      <b-col sm="4">
        <b-button variant="success" class="mt-4" @click="saveItemTag" size="md">Save</b-button>
      </b-col>
      <b-col sm="4">
        <b-form-input v-model="search" placeholder="Search"></b-form-input>
      </b-col>
    </b-row>
    <div class="table-responsive mb-0">
      <b-table
          :key="stores.key"
          :items="stores.data"
          :fields="fields"
          responsive="sm"
          :filter="filter"
          :current-page="current_page"
      >
        <template v-slot:cell(r_id)="row">
          {{row.item.ref_id}}
        </template>
        <template v-slot:cell(restaurant_name)="row">
          {{row.item.restaurant.name}}
        </template>
        <template v-slot:cell(brand)="row">
          {{row.item.brand.name}}
        </template>
        <template v-slot:cell(location)="row">
          {{row.item.restaurant.location}}
        </template>
        <template v-slot:cell(toggle)="row">
          <b-checkbox switch @change="toggleItem($event,row.item)" :checked="row.item?.stock_in == true ? true : false"></b-checkbox>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button @click="deleteItemTag(row.item)" variant="danger" size="sm">
            <i class="fa fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination :key="stores.key" v-model="current_page" :total-rows="stores.total" :per-page="stores.per_page"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.custom-control-label::before {
  border: 1px solid #f11818;
}
.custom-switch .custom-control-label::after{
  background-color: #f11818;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #29a900;
  background-color: #29a900;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
</style>